@if (canViewMenu()) {
  <button
    [sbMenuTriggerFor]="actionsMenu.panel"
    [attr.aria-label]="'Actions' | translate"
    sb-icon-button
    [color]="'transparent'"
  >
    <sb-icon [name]="'ellipsis-v'" />
  </button>
  <sb-menu #actionsMenu>
    <ng-template sbMenuDeferredContent>
      @if (canInvite()) {
        <button sbMenuItem [leadingIcon]="'mail-send-cute-re'" (triggered)="invite(employee().id)">
          {{ 'Invite' | translate }}
        </button>
      }
      @if (canResendInvite()) {
        <button sbMenuItem [leadingIcon]="'mail-send-cute-re'" (triggered)="resendEmployeeInvite(employee().id)">
          {{ 'Resend invite' | translate }}
        </button>
      }
      @if (canActivate()) {
        <button sbMenuItem [leadingIcon]="'unlock-cute-re'" (triggered)="activate(employee().id)">
          {{ 'Activate' | translate }}
        </button>
      }
      @if ((canInvite() || canResendInvite() || canActivate()) && (canDeactivate() || canAnonymize())) {
        <sb-menu-separator />
      }
      @if (canDeactivate()) {
        <button sbMenuItem variant="destructive" [leadingIcon]="'lock-cute-re'" (triggered)="deactivate(employee().id)">
          {{ 'Deactivate' | translate }}
        </button>
      }
      @if (canAnonymize()) {
        <button sbMenuItem variant="destructive" [leadingIcon]="'delete-2-cute-re'" (triggered)="anonymize()">
          {{ 'Anonymize' | translate }}
        </button>
      }
    </ng-template>
  </sb-menu>
  <app-dialog-confirm-high-impact
    [title]="'Anonymize employee?' | translate"
    [confirmButtonLabel]="'Anonymize employee' | translate"
    [matchLabel]="'Type employee’s name below' | translate"
    [matchValue]="employee().name"
    [matchError]="'Username is incorrect.' | translate"
  >
    <p>
      {{
        'Deleting an employee with all associated data cannot be undone. Timesheets will be retained, but will no longer be traceable to the employee in question.You can confirm this action by entering the employee’s name below:'
          | translate
      }}
    </p>
  </app-dialog-confirm-high-impact>
}
